import Heading from 'components/Heading'
import React from 'react'

import baplieMobileAddDischargeBaplie from './Images/baplie-mobile-add-discharge-baplie.png'
import baplieMobileAllFilesUpdated from './Images/baplie-mobile-all-files-updated.png'
import baplieMobileNotificationSyncCompleted from './Images/baplie-mobile-notification-sync-completed.png'
import baplieMobileProgressBaplies from './Images/baplie-mobile-progress-baplies.png'
import baplieMobileSelectSourceLoadServer from './Images/baplie-mobile-select-source-load-server.png'
import baplieMobileSelectSourceLoadUsb from './Images/baplie-mobile-select-source-load-usb.png'
import baplieRestowHistoryPanel from './Images/baplie-restow-history-panel.png'
import baplieRestowUploadButtons from './Images/baplie-restow-upload-buttons.png'
import baplieSummaryPageContainers from './Images/baplie-summary-page-containers.png'
import baplieSyncPendingStatus from './Images/baplie-sync-pending-status.png'
import baplieViewHistoryButton from './Images/baplie-view-history-button.png'
import baplieWebAllSyncCompleted from './Images/baplie-web-all-sync-completed.png'
import baplieWebUploadDialog from './Images/baplie-web-upload-dialog.png'
import restowMobileLoadFromServerDone from './Images/restow-mobile-load-from-server-done.png'

const BaplieRestowWebUpload = () => (
  <div>
    <Heading isDark level={2}>
      BAPLIE &amp; Restow File Upload via Web Dashboard
    </Heading>

    <Heading isDark level={3}>
      Overview
    </Heading>
    <p>
      This page explains the step-by-step process to upload and manage BAPLIE
      and Restow files using the web dashboard.
    </p>

    <Heading isDark level={3}>
      Accessing and Uploading BAPLIE / Restow Files
    </Heading>
    <ul>
      <li>
        In the Ship Overview page, locate the component:{' '}Baplie / Restow.
      </li>
      <li>
        Under this component the following sections are available:{' '}
        Discharge / Load /{' '}Restow.
      </li>
      <li>Each section has its own Upload button.</li>
      <li>Navigate to the Baplie / Restow component.</li>
      <li>
        Select the appropriate section: Discharge / Load / Restow.
      </li>
      <li>Click on the Upload button for the required section.</li>
    </ul>
    <img
      alt="Ship Overview page showing Baplie / Restow component with Discharge, Load and Restow upload buttons"
      src={baplieRestowUploadButtons}
    />

    <p>
      Either drag and drop the respective file into the designated area or
      choose the file manually and click the Upload button to
      proceed.
    </p>
    <img
      alt="Web dashboard file upload dialog showing drag-and-drop area and Upload button"
      src={baplieWebUploadDialog}
    />

    <Heading isDark level={3}>
      Post Upload Status (Web Dashboard)
    </Heading>
    <p>Once the file is uploaded:</p>
    <ul>
      <li>File name, device name, and status will be displayed.</li>
      <li>
        Initial status will be &quot;Sync Pending&quot;.
      </li>
    </ul>
    <img
      alt="Web dashboard Baplie / Restow component showing Sync Pending status after file upload"
      src={baplieSyncPendingStatus}
    />

    <Heading isDark level={3}>
      Mobile Device Notification &amp; Web Dashboard Sync
    </Heading>
    <ul>
      <li>
        A notification will appear on the mobile device and cannot be ignored or
        closed.
      </li>
      <li>
        It will appear latest within 60 seconds, and the crew must proceed to
        update the file.
      </li>
      <li>
        After the successful update a confirmation message will be displayed on
        the mobile device and the status will change to{' '}
        &quot;Sync Completed&quot;.
      </li>
    </ul>
    <img
      alt="Mobile device showing BAPLIE Update Available notification and Discharge baplie updated confirmation, alongside web dashboard showing Sync Completed status"
      src={baplieMobileNotificationSyncCompleted}
    />

    <Heading isDark level={3}>
      BAPLIE Update in Mobile Device – Alternate Options
    </Heading>

    <Heading isDark level={4}>
      1st Alternative Option
    </Heading>
    <p>
      Once the C/O informs the OOW that the Baplie file is uploaded, the OOW
      can load it from the server even before the notification arrives.
    </p>
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '1rem' }}>
      <img
        alt="Mobile device Progress screen with Baplies and restows highlighted"
        src={baplieMobileProgressBaplies}
      />
      <img
        alt="Mobile device Baplies and restows screen with Add discharge baplie circled"
        src={baplieMobileAddDischargeBaplie}
      />
      <img
        alt="Mobile device Select BAPLIE Source screen with Load from Server circled"
        src={baplieMobileSelectSourceLoadServer}
      />
    </div>

    <Heading isDark level={4}>
      2nd Alternative Option
    </Heading>
    <p>
      Load from a USB stick, which is the current standard process for uploading
      the Baplie file.
    </p>
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
      <img
        alt="Mobile device Baplies and restows screen with Add discharge baplie circled"
        src={baplieMobileAddDischargeBaplie}
      />
      <img
        alt="Mobile device Select BAPLIE Source screen with Load from USB circled"
        src={baplieMobileSelectSourceLoadUsb}
      />
    </div>

    <Heading isDark level={3}>
      Restow File Upload &amp; Update
    </Heading>
    <ul>
      <li>Upload the Restow file via the web dashboard.</li>
      <li>
        <strong>Note:</strong> Mobile notifications for restow are not yet
        supported. The C/O must inform the OOW once the file has been uploaded
        in the web dashboard.
      </li>
      <li>
        The OOW should choose{' '}
        &quot;Load from Server (Automatic)&quot;in the mobile
        device.
      </li>
      <li>
        After completing the update click &quot;Done&quot;.
      </li>
      <li>
        The updated data will then be reflected on both the mobile device and
        the web dashboard.
      </li>
    </ul>
    <img
      alt="Mobile device showing Restows screen with Load from Server (Automatic) option and Done button"
      src={restowMobileLoadFromServerDone}
    />

    <Heading isDark level={3}>
      Final Sync Status
    </Heading>
    <p>
      <strong>Mobile device:</strong> All files updated.
    </p>
    <img
      alt="Mobile device Baplies and restows screen showing all files loaded with green checkmarks"
      src={baplieMobileAllFilesUpdated}
    />

    <p>
      <strong>Web dashboard:</strong> All components show &quot;Sync
      completed&quot;.
    </p>
    <img
      alt="Web dashboard Baplie / Restow component showing Sync Completed for Discharge, Load, and Restow"
      src={baplieWebAllSyncCompleted}
    />

    <p>
      After all files are synced, container details will appear on the Summary
      page.
    </p>
    <img
      alt="Web dashboard Summary page showing container moves progress and productivity overview after files are synced"
      src={baplieSummaryPageContainers}
    />

    <p>
      <strong>Note on restow file upload:</strong> The current process for
      restow files remains unchanged, as only one restow file can be uploaded
      during cargo operations. However, if no restow moves have been executed
      during cargo operations, a revised restow file can be uploaded. To do
      this, the restows must first be reset in the mobile device, after which
      the revised restow file can be uploaded via the web dashboard.
    </p>

    <Heading isDark level={3}>
      View History Feature
    </Heading>
    <p>
      Click &quot;View History&quot; in the Baplie / Restow
      component.
    </p>
    <img
      alt="Web dashboard Baplie / Restow component with View History button highlighted"
      src={baplieViewHistoryButton}
    />

    <ul>
      <li>Displays the history of files uploaded via the web dashboard.</li>
      <li>Allows the download of individual files.</li>
      <li>Separate views for Discharge, Load, and Restow.</li>
    </ul>
    <p>
      <strong>Note:</strong> Only files uploaded through the web dashboard will
      be visible in the &quot;View History&quot; section. Files uploaded via USB
      stick on the mobile device will not be displayed.
    </p>
    <img
      alt="Baplie / Restow History panel showing All, Discharge, Load, and Restow tabs with Download buttons for each file"
      src={baplieRestowHistoryPanel}
    />
  </div>
)

export default BaplieRestowWebUpload
